import React, { Component } from 'react'
import { Button, Box } from '@material-ui/core'
import Sale from '../components/sale_amp'
import axios from 'axios'
import { FB_API_URL, parseJwt } from '../lib/env'
import withSale from '../container/SaleProvider/withSale'
import { flowRight } from 'lodash'
import ClientInfo from '../components/client/ClientInfo'

class Home extends Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedTab: 0,
      seoStatus: null,
      saleFoundByPhone: null,
      creditRequests: [],
      undecidedCreditRequests: [],
      unsentCreditRequests: []
    }
  }

  componentDidMount() {
    this.props.saleStore.init()
    this.getUndecidedCreditRequests()
    this.getUnsentCreditRequests()
  }

  navAmp = () => {
    let state = {
      creditRequests: this.state.creditRequests
    }

    /*   if (this.props.seo.status && this.props.seo.status.TicketNum) {
      state.seoNumber = this.props.seo.status.TicketNum
    }*/

    this.props.history.push({
      pathname: '/sales_list_amp',
      state: state
    })
  }

  navOpa = () => {
    let state = {
      creditRequests: this.state.creditRequests
    }

    /*   if (this.props.seo.status && this.props.seo.status.TicketNum) {
      state.seoNumber = this.props.seo.status.TicketNum
    }*/

    this.props.history.push({
      pathname: '/sales_list_opa',
      state: state
    })
  }

  getUnsentCreditRequests = () => {
    axios
      .get(FB_API_URL + '/finbroker/credit_request/getUnsentCreditRequests', {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      })
      .then(response => {
        this.setState({
          unsentCreditRequests: response.data
        })
      })
      .catch(error => {
        console.log(error.message)
      })
  }

  getUndecidedCreditRequests = () => {
    axios
      .get(
        FB_API_URL + '/finbroker/credit_request/getUndecidedCreditRequests',
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        }
      )
      .then(response => {
        console.log(response.data)
        this.setState({
          undecidedCreditRequests: response.data
        })
      })
      .catch(error => {
        console.log(error.message)
      })
  }

  render() {
    const { saleStore } = this.props

    let token = localStorage.getItem('token')
    let user = null
    if (token) {
      user = parseJwt(localStorage.getItem('token'))
    }

    return (
      <div>
        <div style={{ marginBottom: '10px' }}>
          <Button
            className="button_small button_grey_color"
            variant="contained"
            color="primary"
            style={{ marginRight: '10px' }}
            onClick={this.navAmp.bind(this)}
          >
            РЛ АМП
          </Button>
          <Button
            className="button_small button_grey_color"
            variant="contained"
            color="primary"
            style={{ marginRight: '10px' }}
            onClick={this.navOpa.bind(this)}
          >
            РЛ ОПА
          </Button>
          <Button
            className="button_small button_grey_color"
            variant="contained"
            color="primary"
            onClick={() => this.props.history.push('/credit_requests')}
          >
            Кредитные заявки
          </Button>
        </div>
        {saleStore.sale && (
          <Box my={1}>
            <ClientInfo sale={saleStore.sale} />
          </Box>
        )}
        {saleStore.sale && (
          <div className="paper-nohover" style={{ marginTop: '10px' }}>
            <Sale sale={saleStore.sale} seoNumber={saleStore.sale.seoNumber} />
          </div>
        )}

        {user && (
          <div
            style={{
              padding: '10px',
              marginTop: '20px',
              fontSize: '18px',
              fontWeight: 'bold'
            }}
          >
            {user.firstName} {user.lastName}
          </div>
        )}

        <div>
          <div
            onClick={() =>
              this.props.history.push({
                pathname: '/credit_requests',
                state: { selectedStatus: 'unanswered' }
              })
            }
            style={{
              cursor: 'pointer',
              width: '300px',
              borderRadius: '10px',
              minWidth: '250px',
              textAlign: 'center',
              margin: '10px',
              borderColor:
                this.state.undecidedCreditRequests.length === 0
                  ? 'rgba(0,255,100,0.5)'
                  : 'rgba(255, 0, 0, 0.3)',
              borderWidth: '1px',
              backgroundColor:
                this.state.undecidedCreditRequests.length === 0
                  ? 'rgba(126,255,189,0.2)'
                  : 'rgba(255, 0, 0, 0.05)',
              borderStyle: 'solid',
              float: 'left'
            }}
          >
            <div
              style={{
                color:
                  this.state.undecidedCreditRequests.length === 0
                    ? '#07bf91'
                    : '#ff5353',
                fontWeight: '400',
                marginTop: '25px',
                marginLeft: '10px',
                marginRight: '10px',
                fontSize: '16px'
              }}
            >
              Заявки без решения
            </div>
            <div
              style={{
                marginTop: '20px',
                marginBottom: '20px',
                color:
                  this.state.undecidedCreditRequests.length === 0
                    ? '#07bf91'
                    : '#ff5353',
                fontSize: '40px',
                fontWeight: '700'
              }}
            >
              {this.state.undecidedCreditRequests.length}
            </div>
          </div>

          <div
            onClick={() =>
              this.props.history.push({
                pathname: '/credit_requests',
                state: { selectedStatus: 'unsent' }
              })
            }
            style={{
              cursor: 'pointer',
              width: '300px',
              borderRadius: '10px',
              minWidth: '250px',
              textAlign: 'center',
              margin: '10px',
              borderColor:
                this.state.unsentCreditRequests.length === 0
                  ? 'rgba(0,255,100,0.5)'
                  : 'rgba(255, 0, 0, 0.3)',
              borderWidth: '1px',
              backgroundColor:
                this.state.unsentCreditRequests.length === 0
                  ? 'rgba(126,255,189,0.2)'
                  : 'rgba(255, 0, 0, 0.05)',
              borderStyle: 'solid',
              float: 'left'
            }}
          >
            <div
              style={{
                color:
                  this.state.unsentCreditRequests.length === 0
                    ? '#07bf91'
                    : '#ff5353',
                fontWeight: '400',
                marginTop: '25px',
                marginLeft: '10px',
                marginRight: '10px',
                fontSize: '16px'
              }}
            >
              Неотправленные заявки
            </div>
            <div
              style={{
                marginTop: '20px',
                marginBottom: '20px',
                color:
                  this.state.unsentCreditRequests.length === 0
                    ? '#07bf91'
                    : '#ff5353',
                fontSize: '40px',
                fontWeight: '700'
              }}
            >
              {this.state.unsentCreditRequests.length}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default flowRight(withSale)(Home)
